import { globalConstants, surveyQuestionsConstants } from "../../constants";

const {
  SURVEY_DATA,
  GET_CUSTOMER,
  IS_SURVEY_SUBMITTED,
  SURVEY_SUBMITTED,
  GET_QUESTIONS_ARRAY,
  GET_THEME_FOR_SURVEY,
  GET_BRAND_DETAIL_BY_ID,
  IS_ALLOWED_TO_VIEW_SURVEY,
} = surveyQuestionsConstants;
const { SUCCESS, FAILURE } = globalConstants;
const initialState = {
  allResponsesArray: [],
  questionsArray: [],
  customerDetail: {},
  surveyTheme: {},
  brandDetail: {},
  surveyId: null,
  isSurveySubmitted: false,
  isAllowedToViewSurvey: true,
  isCustomerSurveySubmitted: false,
};
//Customer Survey reducer
export const customerSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUESTIONS_ARRAY + SUCCESS:
      return {
        ...state,
        questionsArray: action.data?.surveyQuestions?.sort(
          (a, b) => a.questionOrder - b.questionOrder
        ),
        allResponsesArray: action.data?.allSurveyResponseRecipients,
      };
    case GET_QUESTIONS_ARRAY + FAILURE:
      return {
        ...state,
        questionsArray: [],
        allResponsesArray: [],
      };
    case GET_CUSTOMER + SUCCESS:
      return {
        ...state,
        customerDetail: action.data,
      };
    case GET_CUSTOMER + FAILURE:
      return {
        ...state,
        customerDetail: {},
      };
    case GET_THEME_FOR_SURVEY + SUCCESS:
      return {
        ...state,
        surveyTheme: action.data || {},
      };
    case GET_THEME_FOR_SURVEY + FAILURE:
      return {
        ...state,
        surveyTheme: {},
      };
    case GET_BRAND_DETAIL_BY_ID + SUCCESS:
      return {
        ...state,
        brandDetail: action.data || {},
      };
    case GET_BRAND_DETAIL_BY_ID + FAILURE:
      return {
        ...state,
        brandDetail: {},
      };
    case SURVEY_DATA + SUCCESS:
      return {
        ...state,
        surveyId: action.data?.surveyQuestions[0]?.surveyId || null,
      };
    case IS_ALLOWED_TO_VIEW_SURVEY + SUCCESS:
      return {
        ...state,
        isAllowedToViewSurvey: action.data,
      };
    case SURVEY_SUBMITTED + SUCCESS:
      return {
        ...state,
        isSurveySubmitted: action.data,
      };
    case SURVEY_DATA + FAILURE:
      return {
        ...state,
        surveyId: null,
      };
    case IS_SURVEY_SUBMITTED + SUCCESS:
      return {
        ...state,
        isCustomerSurveySubmitted: action.data,
      };
    default:
      return state;
  }
};
